import moderations from './moderations'

export default [...moderations]
